const EDIT_ADMIN_DRAFT_PREFIX = 'admin:adminDraft:edit:'
export const NEW_ADMIN_DRAFT_KEY = 'admin:adminDraft:new'

const ADMIN_DRAFT_FIELDS = [
    'role',
    'accessMode',
    'email',
    'phone',
    'name',
    'memo',
    'password',
]

const getSessionStorage = () => {
    if (typeof window === 'undefined') {
        return null
    }

    return window.sessionStorage
}

const parseNumberValue = (value, fallbackValue) => {
    if (value === undefined || value === null || value === '') {
        return fallbackValue
    }

    const parsedValue = Number(value)

    return Number.isNaN(parsedValue) ? fallbackValue : parsedValue
}

// 관리자 폼에서 다시 입력 비용이 큰 값만 sessionStorage에 남긴다.
export const createAdminDraftPayload = ({ data = {} }) => {
    return {
        data: {
            role: data.role ?? 0,
            accessMode: data.accessMode || 'default',
            email: data.email || '',
            phone: data.phone || '',
            name: data.name || '',
            memo: data.memo || '',
            password: data.password || '',
        }
    }
}

// 서버 기본값 위에 draft만 덮어써서 새로고침 뒤에도 작성 흐름을 이어간다.
export const applyAdminDraft = ({ baseData = {}, draft }) => {
    if (!draft) {
        return {
            data: baseData,
        }
    }

    const draftData = draft.data || {}
    const nextData = {
        ...baseData,
    }

    ADMIN_DRAFT_FIELDS.forEach((field) => {
        if (draftData[field] === undefined) {
            return
        }

        if (field === 'role') {
            nextData[field] = parseNumberValue(draftData[field], baseData[field] ?? 0)
            return
        }

        nextData[field] = draftData[field]
    })

    return {
        data: nextData,
    }
}

export const createEditAdminDraftKey = (adminId) => `${EDIT_ADMIN_DRAFT_PREFIX}${adminId}`

export const readAdminDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return null
    }

    try {
        const storedValue = storage.getItem(draftKey)
        return storedValue ? JSON.parse(storedValue) : null
    } catch (_error) {
        return null
    }
}

export const saveAdminDraft = (draftKey, draftValue) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.setItem(draftKey, JSON.stringify(draftValue))
    } catch (_error) {
        // sessionStorage가 막혀 있어도 작성 흐름은 그대로 유지한다.
    }
}

export const clearAdminDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.removeItem(draftKey)
    } catch (_error) {
        // storage 정리에 실패해도 화면 동작은 계속 진행한다.
    }
}
